import { useConfirmDialog } from "@vueuse/core"

const supervisorLoginDrawerState = useConfirmDialog()

export const useSupervisorLoginDrawer = () =>
  supervisorLoginDrawerState
